import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-duplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['../../../../../styles/global/_management-styles.scss']
})
export class DuplicateComponent {
  @Input() tooltip = '';
  @Input() defaultIcon = 'file_copy';
  @Input() customCssClasses: Array<string> = [];
  @Output() duplicateItem: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
  }

  onDuplicateItemClicked($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.duplicateItem.emit(true);
  }
}
